import React from "react";
import ReactDOM from "react-dom";
import { createBrowserHistory } from "history";
import { Router, Route, Switch } from "react-router-dom";
import { createMuiTheme, MuiThemeProvider } from "@material-ui/core/styles";

import indexRoutes from "routes/index.jsx";
import { AuthProvider } from "context/AuthContext";

import "assets/scss/material-dashboard-pro-react.css?v=1.4.0";

const hist = createBrowserHistory();

const theme = createMuiTheme({
  palette: {
    primary: { main: "#1a237e" },
    secondary: { main: "#1565c0" }
  },
  typography: {
    useNextVariants: true,
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
  },
  overrides: {
    MuiDialog: {
      paper: {
        borderRadius: "16px",
        overflow: "hidden"
      }
    },
    MuiDialogContent: {
      root: {
        padding: "24px"
      }
    },
    MuiBackdrop: {
      root: {
        backgroundColor: "rgba(15, 23, 42, 0.6)"
      }
    }
  }
});

ReactDOM.render(
  <MuiThemeProvider theme={theme}>
    <AuthProvider>
      <Router history={hist}>
        <Switch>
          {indexRoutes.map((prop, key) => {
            return <Route path={prop.path} component={prop.component} key={key} />;
          })}
        </Switch>
      </Router>
    </AuthProvider>
  </MuiThemeProvider>,
  document.getElementById("root")
);
